import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {environment} from '../../../environments/environment';
import {ApiService} from './api.service';

@Injectable()
export class LegalAcceptanceGuardService implements CanActivate {
  constructor(private api: ApiService, private router: Router) {}

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if(!environment.requireLegalAcceptance || !this.api.userRole?.isCustomer) {
      return true;
    }
    if(localStorage.getItem('legalAccepted') === 'true') {
      return true;
    }
    sessionStorage.setItem('legalReturnUrl', state.url);
    this.router.navigate(['/legal-acceptance']);
    return false;
  }
}
